/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { gridSize } from './constants';
var labelTextStyles = css({
  paddingRight: 0.5 * gridSize,
  paddingLeft: 0.5 * gridSize
});
export default function LabelText(_ref) {
  var children = _ref.children;
  return jsx("span", {
    css: labelTextStyles
  }, children);
}